export default "__VITE_ASSET__8b6cafc4__"